



















import { Component, Vue, Prop } from 'vue-property-decorator';
import ModalSimplePopup from '@/components/ModalSimplePopup.vue';

@Component({
  components: {
    ModalSimplePopup
  }
})
export default class Modal extends Vue {
  @Prop({ type: Boolean, required: true })
  isOpen!: boolean;

  @Prop({ type: String, default: '' })
  title!: string;

  @Prop({ type: String, default: '' })
  text!: string;

  @Prop({ type: String, default: '' })
  buttonOK!: string;

  @Prop({ type: String, default: '' })
  buttonNG!: string;
}
